<template>
  <div class="box">
    <Row class="box-head">
        <Col offset="1" span="22" class="head-option">
            <Input style="width: 180px" v-model="search" class="option-select" placeholder="会员姓名/电话" />
            <DatePicker v-model="reservationDate" @on-change="handleDateChange" placeholder="预订日期" type="daterange" placement="bottom-start" style="width:200px;margin-right:20px;" :editable="false"></DatePicker >
            <Select v-model="stadiumCategoryId" style="width:200px;margin-right:20px;" placeholder="场地类型" clearable>
                <Option v-for="item in stadiumCategoryList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Select v-model="stateIdx" style="width:200px;margin-right:20px;" placeholder="状态" clearable>
                <Option v-for="(item, index) in stateList" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
            <Button type="success" @click="handleSearch">搜索</Button>
        </Col>
    </Row>
    <Row class="box-body table-wrap">
      <Col span="24">
      <Table ref="table" stripe :columns="columns" :data="list" disabled-hover></Table>
      </Col>
    </Row>
    <Row class="box-foot">
      <Col offset="1" span="22" class="foot-option">
      <div class="option-ctrl">
      </div>
      <Page @on-change="handlePage" :total="total" :current="currentPage" @on-page-size-change="pageSizeChanged" show-total show-sizer></Page>
      </Col>
    </Row>

    <Modal v-model="showOrderModal" width="360">
      <div class="modal-header">
          <h3>订单信息</h3>
      </div>
      <div class="modal-buddy" style="margin-top:20px;">
        <Form ref="orderModal" :model="orderModal" class="modal-form" :label-width="80">
          <Form-item label="订单编号" prop="orderCode">{{orderModal.orderCode}}</Form-item>
          <Form-item label="场地" prop="stadium">{{orderModal.stadium}}</Form-item>
          <Form-item label="场地类型" prop="stadiumCategory">{{orderModal.stadiumCategory}}</Form-item>
          <Form-item label="日期" prop="reservationDay">{{orderModal.reservationDay}}</Form-item>
          <Form-item label="时间" prop="reservationTime">{{orderModal.reservationTime}}</Form-item>
          <Form-item label="支付状态" prop="payment">{{orderModal.payment}}</Form-item>
          <Form-item label="金额" prop="price">{{orderModal.price}}</Form-item>
          <Form-item label="客户" prop="username">{{orderModal.username}}</Form-item>
          <Form-item label="电话" prop="phone">{{orderModal.phone}}</Form-item>
          <Form-item v-if="orderModal.status != 2 && isGoPay && orderModal.orginalPayMethod==8" :label="(orderModal.status==0)?'支付方式':'退款方式'">
              储值卡
          </Form-item>
          <Form-item v-else-if="orderModal.status != 2 && isGoPay && orderModal.orginalPayMethod==1 && orderModal.from == 2" :label="(orderModal.status==0)?'支付方式':'退款方式'">
              微信
          </Form-item>
          <div v-else-if="orderModal.status != 2 && isGoPay && orderModal.orginalPayMethod!=8">
              <Form-item :label="(orderModal.status==0)?'支付方式':'退款方式'" prop="payMethod" error="请选择支付方式!" required>
                  <PayTypeSelect @on-change="handleResetCardId" v-model="orderModal.payMethod" placeholder="请选择" :showCardPay="orderModal.userType == 1 && !isRefund" :clearable="false"/>
              </Form-item>
              <Form-item v-if="orderModal.payMethod == 8" label="储值卡" prop="cardId" error="请选择储值卡!" required>
                  <Select v-model="orderModal.cardId" style="width:200px;" placeholder="储值卡" :clearable="false">
                      <Option v-for="item in cardList" :value="item.card_user_id" :key="item.card_user_id">{{ item.name }}</Option>
                  </Select>
              </Form-item>
          </div>
        </Form>
      </div>
      <div slot="footer" class="modal-buttons">
        <Button type="success" v-if="orderModal.status == 0 && !isGoPay" @click="handlePayOrRefundClick">支付</Button>
        <Button v-if="orderModal.status == 0 && !isGoPay" @click="handleCancel">取消预订</Button>
        <Button type="success" v-if="orderModal.status == 0 && isGoPay" @click="handlePayModal">确定</Button>
        <Button v-if="orderModal.status == 0 && isGoPay" @click="showOrderModal = false;">取消</Button>
        <Button type="success" v-if="orderModal.status == 1 && !isGoPay" @click="handleInGym">确认到场</Button>
        <Button v-if="orderModal.status == 1 && !isGoPay" @click="handlePayOrRefundClick">退款</Button>
        <Button type="success" v-if="orderModal.status == 1 && isGoPay" @click="handleRefund">确认</Button>
        <Button v-if="orderModal.status == 1 && isGoPay" @click="showOrderModal = false;">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import PayTypeSelect from 'components/form/PayTypeSelect'

export default {
  components: { PayTypeSelect },
  data() {
    const formatDate = (source, format) => {
      const o = {
        'M+': source.getMonth() + 1, // 月份
        'd+': source.getDate(), // 日
        'H+': source.getHours(), // 小时
        'm+': source.getMinutes(), // 分
        's+': source.getSeconds(), // 秒
        'q+': Math.floor((source.getMonth() + 3) / 3), // 季度
        'f+': source.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (source.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return format
    };
    const resetOrder = order => {
        this.isGoPay = false;
        this.orderModal = {
            orderId: order.id,
            orderCode: order.order_sn,
            stadium: order.space_name,
            stadiumCategory: order.space_type_name,
            reservationDay: order.date_desc,
            reservationTime: order.time_desc,
            payment: this.stateList[order.status].name,
            price: order.amount,
            userId: order.user_id,
            userType: order.user_type,
            username: order.username,
            phone: order.phone,
            payMethod: order.pay_type,
            orginalPayMethod: order.pay_type,
            from: order.from,
            cardId: '',
            status: order.status,
        };

        this.getCardList();
    };
    return {
        search: '',
        reservationDate: [],
        startTime: '',
        overTime: '',
        stadiumCategoryList: [],
        stadiumCategoryId: '',
        // stateList: ['未支付', '已支付', '已到场', '已离场', '已退款', '已取消'],
        stateList: [{name:'未支付',code:0}, {name:'已支付',code:1}, {name:'已到场',code:2}, {name:'已退款',code:4}, {name:'已取消',code:5}],
        stateIdx: '',
        currentPage: 1,
        pageSize: 10,
        total: 0,
        columns: [
            { title: '订单编号', key: 'order_sn' },
            { title: '场地类型', key: 'space_type_name' },
            { title: '场地', key: 'space_name' },
            { title: '预订时间', key: 'start_time', render: (h, params)=>{
              const dateString = params.row.date_desc + ' ' + params.row.time_desc;
              return (<div>{dateString}</div>);
            } },
            { title: '会员', key: 'username'},
            { title: '金额', key: 'amount' },
            { title: '状态', key: 'status', render: (h, params)=>{
              // 0-未支付，1-已支付，2-已到场，3-已离场，4-已退款，5-已取消
              const value = params.row.status;
              const stateItem = this.stateList.find(item=>(item.code==value));
              return (<div>{stateItem.name}</div>);
            } },
            { title: '付款方式', key: 'pay_type_name' },
            { title: '退款时间', key: 'refund_time', render: (h, params)=>{
              let dateString = '';
              if (!!params.row.refund_time) {
                const date = new Date(params.row.refund_time*1000);
                dateString = formatDate(date, 'yyyy-MM-dd HH:mm');
              }
              return (<div>{dateString}</div>);
            } },
            {
              title: '操作',
              key: 'option',
              width: 150,
              render: (h, params) => {
                  let leftLabel = '';
                  let rightLabel = '';
                  if (params.row.status == 0) {
                      leftLabel = '支付';
                      rightLabel = '取消预订';
                  } else if (params.row.status == 1) {
                      leftLabel = '确认到场';
                      rightLabel = '退款';
                  }

                  const show = hell=>{
                    resetOrder(params.row);
                    if (leftLabel == '支付') {
                      if (hell == 1) {
                        this.isRefund = false;
                        this.showOrderModal = true;
                        this.handlePayOrRefundClick();
                      } else if (hell == 2) {
                        this.handleCancel();
                      }
                    } else if (leftLabel == '确认到场') {
                      if (hell == 1) {
                        this.handleInGym();
                      } else if (hell == 2) {
                        this.isRefund = true;
                        this.showOrderModal = true;
                        this.handlePayOrRefundClick();
                      }
                    }
                  };
                  return (
                    <div style="display: flex;flex-direction: row;justify-content: space-around;">
                        <a onClick={() => {
                          show(1);
                        }}>{leftLabel}</a>
                        <a style="color:red;" onClick={() => {
                          show(2);
                        }}>{rightLabel}</a>
                    </div>
                  );
                }
            }
        ],
        list: [],
        isRefund: false,
        showOrderModal: false,
        orderModal: {
            orderId: '',
            orderCode: '',
            stadium: '',
            stadiumCategory: '',
            reservationDay: '',
            reservationTime: '',
            payment: '',
            price: '',
            userId: '',
            userType: '',
            username: '',
            phone: '',
            payMethod: '',
            orginalPayMethod: '',
            status: ''
        },
        cardList: [],
        isGoPay: false,
    };
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.getList();
    },
    handlePage(val) {
      this.currentPage = val;
      this.getList();
    },
    pageSizeChanged(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    getList() {
      return this.$service.post('/Web/SpaceOrder/getOrderList', {
            search : this.search,
            start_time: this.startTime,
            end_time: this.overTime,
            space_type_id: this.stadiumCategoryId,
            status: this.stateIdx,
            page_no: this.currentPage,
            page_size: this.pageSize,
        }).then(res => {
          if (res.data.errorcode == 0) {
            this.total = parseInt(res.data.data.count);
            this.list = [];
            if (Array.isArray(res.data.data.list)) {
              this.list = res.data.data.list;
            }
          } else {this.$Message.error(res.data.errormsg);}
        });
    },
    getStadiumCategoryList() {
      const nb = 1;
      return this.$service.post('/Web/Space/getTypes', {nb}).then(res => {
        if (res.data.errorcode == 0) {
          this.stadiumCategoryList = res.data.data;
        } else {this.$Message.error(res.data.errormsg);}
      });
    },
    handleDateChange(arr) {
        if (Array.isArray(arr)) {
            this.startTime = arr[0];
            this.overTime = arr[1];
        }
    },

    handleResetCardId() {
        if (this.orderModal.payMethod == 8) {
            this.orderModal.cardId = 0;
            setTimeout(() => {
                this.$refs['orderModal'].validateField('cardId');
            }, 100);
        }
    },

    handlePayOrRefundClick() {
        this.isGoPay = true;
        setTimeout(() => {
          if (this.orderModal.status != 2 && this.isGoPay && this.orderModal.orginalPayMethod!=8) {
            if (typeof(this.orderModal.payMethod) == 'undefined') {
              this.orderModal.payMethod = 0;
            }
            this.$refs['orderModal'].validateField('payMethod');
          }
        }, 100);
    },
    resetCardId() {
        if (this.orderModal.payMethod != 8) {
            this.orderModal.cardId = '';
        }
    },

    handlePayModal() {
      this.resetCardId();
      return this.$service.post('/Web/SpaceOrder/postPay', {
          space_order_id: this.orderModal.orderId,
          pay_type: this.orderModal.payMethod,
          card_user_id: this.orderModal.cardId
      }).then(res => {
          if (res.data.errorcode == 0) {
              this.$Message.success(res.data.errormsg);
              this.showOrderModal = false;
              this.getList();
          } else {this.$Message.error(res.data.errormsg);}
      });
    },
    handleInGym() {
        return this.$service.post('/Web/SpaceOrder/userSign', {
            space_order_id: this.orderModal.orderId
        }).then(res => {
            if (res.data.errorcode == 0) {
                this.$Message.success(res.data.errormsg);
                this.showOrderModal = false;
                this.getList();
            } else {this.$Message.error(res.data.errormsg);}
        });
    },
    handleRefund() {
      this.resetCardId();
      return this.$service.post('/Web/SpaceOrder/postRefund', {
          space_order_id: this.orderModal.orderId,
          pay_type: this.orderModal.payMethod,
          card_user_id: this.orderModal.cardId
      }).then(res => {
          if (res.data.errorcode == 0) {
              this.$Message.success(res.data.errormsg);
              this.showOrderModal = false;
              this.getList();
          } else {this.$Message.error(res.data.errormsg);}
      });
    },
    handleCancel() {
        return this.$service.post('/Web/SpaceOrder/postRefund', {
            space_order_id: this.orderModal.orderId,
            pay_type: '',
            card_user_id: ''
        }).then(res => {
            if (res.data.errorcode == 0) {
                this.$Message.success(res.data.errormsg);
                this.showOrderModal = false;
                this.getList();
            } else {this.$Message.error(res.data.errormsg);}
        });
    },
    getCardList() {
      if (!this.orderModal.userId) {
        return false;
      }
      return this.$service.post('/Web/SpaceOrder/getValueCards', {
          user_id: this.orderModal.userId
      }).then(res => {
          if (res.data.errorcode == 0) {
              this.cardList = res.data.data;
          } else {this.$Message.error(res.data.errormsg);}
      });
    }
  },
  mounted() {
    this.getList();
    this.getStadiumCategoryList();
  }
};
</script>

<style lang="less">
.box {
  background-color: #fff;

  .box-head {
    border: 1px solid #dddee1;

    .head-option {
      height: 75px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .option-select {
        width: 120px;
        margin-right: 20px;
      }
    }
  }

  .box-body {
    border-left: 1px solid #dddee1;
  }

  .box-foot {
    border: 1px solid #dddee1;
    border-top: none;

    .foot-option {
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .option-ctrl {
        display: flex;
        flex-direction: row;
      }

    }
  }
}
</style>
